import { cn } from '@/lib/utils'
import { formatChatTimestamp } from '@/lib/chatFormat'

export type UserMessageState = 'sent' | 'sending' | 'error'

export type UserMessageProps = {
  content: string
  createdAt: string
  state?: UserMessageState
  errorMessage?: string
  className?: string
}

export function UserMessage({ content, createdAt, state = 'sent', errorMessage, className }: UserMessageProps) {
  const time = formatChatTimestamp(createdAt)
  return (
    <div className={cn('flex flex-col items-end gap-1', className)} data-state={state}>
      <div
        className={cn(
          'max-w-[85%] whitespace-pre-wrap break-words rounded-2xl rounded-br-sm bg-[var(--chat-user-bg)] px-4 py-2 text-sm text-slate-900',
          state === 'sending' && 'opacity-60',
          state === 'error' && 'ring-1 ring-red-300'
        )}
      >
        {content}
      </div>
      <div className="flex items-center gap-2 text-[11px] text-slate-500">
        {state === 'error' ? (
          <span className="text-red-600">{errorMessage ?? "Message non envoyé"}</span>
        ) : null}
        {time ? <time dateTime={createdAt}>{time}</time> : null}
      </div>
    </div>
  )
}
